import React from 'react';

/**
 * Image with WebP source and original fallback + explicit intrinsic dimensions
 * for CLS-friendly rendering. Use in place of <img> for local /images/... files.
 *
 * Props:
 *   src        — image source (local or absolute URL)
 *   alt        — accessible caption (required for a11y & SEO)
 *   width/height (optional) — intrinsic pixel dimensions, passed through to <img>
 *   loading    — defaults to "lazy"; pass "eager" for LCP hero images
 *   fetchpriority — "high" for hero, else omit
 *
 * Browsers use `width`+`height` to reserve space and eliminate layout shift (CLS).
 */
const PictureImage = ({
  src,
  alt = '',
  className = '',
  loading = 'lazy',
  width,
  height,
  fetchpriority,
  ...rest
}) => {
  const dimensionProps = {
    ...(width ? { width } : {}),
    ...(height ? { height } : {}),
    ...(fetchpriority ? { fetchpriority } : {}),
  };
  if (!src || !/\.(jpe?g|png)$/i.test(src) || /^https?:\/\//i.test(src)) {
    return <img src={src} alt={alt} className={className} loading={loading} {...dimensionProps} {...rest} />;
  }
  const webp = src.replace(/\.(jpe?g|png)$/i, '.webp');
  return (
    <picture>
      <source srcSet={webp} type="image/webp" />
      <img src={src} alt={alt} className={className} loading={loading} {...dimensionProps} {...rest} />
    </picture>
  );
};

export default PictureImage;
